export type { CustomsDocument, DocumentStatus } from '../../../../../store/customs-documents/types';

export const BLOB_URL_TTL_MS = 30_000;
export const ERROR_STATUSES: string[] = ['failed', 'invalid'];
